import { Wrench } from "lucide-react";

/**
 * Un grupo de fotos de evidencia, con su etiqueta de quién las tomó.
 *
 * Las de quien entrega y las de quien recibe van separadas y rotuladas (A-01):
 * en un rechazo son justo lo que hay que comparar, y mezcladas no se sabe cuál
 * es cuál.
 *
 * `conHuecos` pinta los recuadros vacíos hasta completar tres: así se ve de un
 * vistazo cuántas faltaban, que es como se mostraba antes la evidencia del
 * asignador. Las de quien recibe son opcionales y no se piden, así que ahí un
 * hueco vacío sugeriría una falta que no existe.
 */
export const GrupoDeEvidencia = ({
  titulo,
  urls,
  conHuecos = false,
  onVer,
}: {
  titulo: string;
  urls: string[];
  conHuecos?: boolean;
  onVer: (url: string) => void;
}) => {
  const casillas: (string | null)[] = conHuecos
    ? [0, 1, 2].map((i) => urls[i] ?? null)
    : urls;

  return (
    <div>
      <p className="mb-3 text-sm font-medium text-gray-600">{titulo}</p>

      {casillas.length === 0 ? (
        <p className="text-sm text-gray-400 italic">Sin fotos</p>
      ) : (
        <div className="flex flex-wrap gap-4">
          {casillas.map((url, i) =>
            url ? (
              <button
                key={i}
                type="button"
                onClick={() => onVer(url)}
                className="desde-izq rounded-xl border border-gray-200 bg-gray-50 flex items-center justify-center flex-shrink-0 overflow-hidden cursor-pointer hover:border-[#477FFA] transition-colors"
                style={{ width: 150, height: 150, animationDelay: `${Math.min(i, 5) * 90}ms` }}
              >
                <img src={url} alt={`${titulo} ${i + 1}`} className="w-full h-full object-contain" />
              </button>
            ) : (
              <div
                key={i}
                className="rounded-xl border border-gray-200 bg-gray-50 flex items-center justify-center flex-shrink-0 overflow-hidden"
                style={{ width: 150, height: 150 }}
              >
                <Wrench className="w-8 h-8 text-gray-300" />
              </div>
            ),
          )}
        </div>
      )}
    </div>
  );
};

export default GrupoDeEvidencia;
